import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizationScopeDirective, LocalizePipe } from '@capital-access/common/localization';
import { NOTIFICATIONS_LOCALIZATION_SCOPE } from '../../constants/notifications-drawer.constants';
import { NotificationDto } from '../../models/notifications-grouped.model';

@Component({
  selector: 'ca-ownership-notification-item',
  templateUrl: './ownership-notification-item.component.html',
  styleUrls: ['./ownership-notification-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DatePipe, LocalizationScopeDirective, LocalizePipe]
})
export class OwnershipNotificationItemComponent {
  notification = input.required<NotificationDto>();
  markAsRead = output<number>();
  delete = output<number>();
  private router = inject(Router);

  readonly localizationScope = NOTIFICATIONS_LOCALIZATION_SCOPE;

  onOpen(): void {
    if (!this.notification().read) {
      this.markAsRead.emit(this.notification().notificationId);
    }
    this.router.navigateByUrl('/data-alerts');
  }

  onDelete(): void {
    this.delete.emit(this.notification().notificationId);
  }
}
